import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/css/tailwind.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/clerk.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/MongoDB.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/next-auth.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/nextjs.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/nodejs.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/prisma.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/react.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/redux.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/typescript.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/vercel.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/zod.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/FrameWorkAndLibraries/zustand.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/tools/git.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/tools/github.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/tools/vscode.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/cards/skill-card.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/about-me.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/achivements.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/email-copy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/featured-product.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/projects/projects-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/saa-portal-spotlight.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PointerHighlight"] */ "/vercel/path0/src/components/ui/pointer-highlight.tsx");
